"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RowSubValue = exports.RowValue = exports.Row = exports.Abbreviation = exports.RowSubType = exports.RowType = exports.Type = exports.Value = exports.RowWrapper = exports.MessageWrapper = exports.Wrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../theme/colors");
exports.Wrapper = styled_components_1.default.div ``;
exports.MessageWrapper = styled_components_1.default.div ``;
exports.RowWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
`;
exports.Value = styled_components_1.default.span `
  margin-right: 2px;
  font-size: 14px;
  color: ${colors_1.GREY3};
`;
exports.Type = styled_components_1.default.span `
  font-size: 14px;
  color: ${colors_1.GREY3};
`;
exports.RowType = styled_components_1.default.span `
  font-size: 13px;
  color: ${colors_1.GREY3};
`;
exports.RowSubType = styled_components_1.default.span `
  font-size: 11px !important;
  color: ${colors_1.GREY3};
`;
exports.Abbreviation = styled_components_1.default.abbr `
  color: ${colors_1.SWEGON_GREEN};

  &[data-tip] {
    text-decoration: underline dotted;
  }
  &:hover {
    cursor: pointer;
  }

  & span {
    color: ${colors_1.SWEGON_GREEN};
  }
`;
exports.Row = styled_components_1.default.div `
  display: flex;
`;
exports.RowValue = styled_components_1.default.span `
  margin-right: 2px;
  font-size: 13px !important;
  color: ${colors_1.GREY3};
`;
exports.RowSubValue = styled_components_1.default.span `
  margin-right: 2px;
  font-size: 11px !important;
  color: ${colors_1.GREY3};
`;
//# sourceMappingURL=TypedValue.styles.js.map